import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
    Card
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"
import SocialLinks from '/components/SocialLinks';
import imagesMetaData from '@/.sourceflow/image_metadata.json';

export default function ImageWithTextBanner({
    global,
    pathPrefix,
    customClass = "",
    content,
    bot,
    buttonTitle,
    buttonLink,
    imageURL,
    imageALT,
    newPageTab = false,
    inverted = false
}) {

    return (
        <section className={`${styles.root} ${customClass}`}>
            <Row className={`m-0 ${inverted ? "flex-row-reverse" : ""}`}>
                <Col md={8} className="left-column py-5">
                    {content ?
                        <div className="mb-4">
                            <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                {content}
                            </SourceFlowText>
                        </div> : null}
                    {bot ?? null }
                    {buttonLink ?
                        <div>
                            <Link href={`${buttonLink}`}>
                                {newPageTab ?
                                    <a className="primaryBtn no-arrow" target="_blank" rel="noopener noreferrer">
                                        {buttonTitle}
                                    </a> :
                                    <a className="primaryBtn no-arrow">
                                        {buttonTitle}
                                    </a>}

                            </Link>
                        </div> : null}
                </Col>
                <Col md={4} className="right-column p-0">
                    <SourceFlowImage
                        src={imageURL ? imageURL : "/site-assets/placeholders/img-placeholder.jpg"}
                        size="1000x500"
                        alt={imageALT}
                        className="card-img bg-white"
                        imagesMetaData={imagesMetaData}
                        path={pathPrefix ? pathPrefix : (`${pathPrefix}.image`) }
                    />
                </Col>
            </Row>
        </section>
    )
}